<div ngbDropdown id="{{ id() }}DatePicker" class="puggles-date-picker puggles-dropdown d-inline-block w-100">
    <button tabindex="0" ngbDropdownToggle type="button" id="{{ id() }}DatePicker"
        class="puggles-dropdown-toggle form-control btn d-flex w-100 p-4 justify-content-between align-items-center text-start">
        <div>{{ selectedValue }}</div>
        <img alt="Down chevron" class="puggles-dropdown-toggle-icon" src="/assets/images/icons/caret-down-grey.svg" [width]="10" />
    </button>
    <div ngbDropdownMenu class="puggles-date-picker-menu" attr.aria-labelledby="{{ id() }}DatePicker">
        <ngb-datepicker class="w-100 p-4 border-0"
            [contentTemplate]="datePickerContent"
            [displayMonths]="4"
            navigation="none"
            outsideDays="hidden"
            [weekdays]="false"
            (dateSelect)="onDateSelected($event)" />
    </div>
</div>

<ng-template #datePickerContent let-dp>
    <div class="puggles-date-picker-content">
        <div class="btn-group d-flex justify-content-end mb-7" role="group">
            <button tabindex="0" type="button" class="btn btn-sm btn-navigate" (click)="navigateToToday(dp)">Today</button>
            <button tabindex="0" type="button" class="btn btn-sm btn-navigate" (click)="navigateToCalendarPage(dp, 1)">Next</button>
        </div>
        <div class="custom-month-grid">
            @for (month of dp.state.months; track month) {
                <div>
                    <div>{{ dp.i18n.getMonthShortName(month.month) }} {{ month.year }}</div>
                    <ngb-datepicker-month [month]="month" />
                </div>
            }
        </div>
    </div>
</ng-template>
